/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RailiumFeldAenderung } from './RailiumFeldAenderung';
import {
    RailiumFeldAenderungFromJSON,
    RailiumFeldAenderungFromJSONTyped,
    RailiumFeldAenderungToJSON,
} from './RailiumFeldAenderung';

/**
 * Änderungen dieses Railium-Einsatzes im Vergleich zum vorherigen Umsatz-Historieneintrag
 * @export
 * @interface RailiumEinsatzDifferenz
 */
export interface RailiumEinsatzDifferenz {
    /**
     * Gibt an, ob der Railium-Einsatz neu, geändert, unverändert oder gelöscht ist
     * @type {string}
     * @memberof RailiumEinsatzDifferenz
     */
    zustand: RailiumEinsatzDifferenzZustandEnum;
    /**
     * Liste der Feldänderungen im Vergleich zum vorherigen Eintrag
     * @type {Array<RailiumFeldAenderung>}
     * @memberof RailiumEinsatzDifferenz
     */
    feldAenderungen?: Array<RailiumFeldAenderung>;
}


/**
 * @export
 */
export const RailiumEinsatzDifferenzZustandEnum = {
    Neu: 'NEU',
    Geaendert: 'GEAENDERT',
    Geloescht: 'GELOESCHT'
} as const;
export type RailiumEinsatzDifferenzZustandEnum = typeof RailiumEinsatzDifferenzZustandEnum[keyof typeof RailiumEinsatzDifferenzZustandEnum];


/**
 * Check if a given object implements the RailiumEinsatzDifferenz interface.
 */
export function instanceOfRailiumEinsatzDifferenz(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zustand" in value;

    return isInstance;
}

export function RailiumEinsatzDifferenzFromJSON(json: any): RailiumEinsatzDifferenz {
    return RailiumEinsatzDifferenzFromJSONTyped(json, false);
}

export function RailiumEinsatzDifferenzFromJSONTyped(json: any, ignoreDiscriminator: boolean): RailiumEinsatzDifferenz {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zustand': json['zustand'],
        'feldAenderungen': !exists(json, 'feldAenderungen') ? undefined : ((json['feldAenderungen'] as Array<any>).map(RailiumFeldAenderungFromJSON)),
    };
}

export function RailiumEinsatzDifferenzToJSON(value?: RailiumEinsatzDifferenz | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zustand': value.zustand,
        'feldAenderungen': value.feldAenderungen === undefined ? undefined : ((value.feldAenderungen as Array<any>).map(RailiumFeldAenderungToJSON)),
    };
}

